import { isNumber } from 'lodash';
import { SectionGridItem, SectionGridItemProps } from './SectionGridItem';
import { getHuminizeDurationInSecFunction } from 'src/i18n/dateLocale';

export type SectionGriDurationItemProps = Omit<SectionGridItemProps, 'value'> & {
  value: number | undefined | null;
};

const humanize = getHuminizeDurationInSecFunction();

export const SectionGriDurationItem = ({ value, ...props }: SectionGriDurationItemProps) => {
  return <SectionGridItem {...props} value={isNumber(value) ? humanize(value) : null} />;
};
